export type AiPromptPurpose =
  | "system"
  | "summarization"
  | "profile_extraction";

export interface AiPromptTemplate {
  id: number;
  purpose: AiPromptPurpose;
  name: string;
  content: string;
  description: string | null;
  isActive: boolean;
  version: number;
  metadata: {
    temperature?: number;
    max_tokens?: number;
    model?: string;
    [key: string]: unknown;
  };
  personaId: number | null;
  personaName?: string;
  personaSlug?: string;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AiPromptTemplateFormData {
  purpose: AiPromptPurpose;
  name: string;
  content: string;
  description?: string;
  personaId?: number | null;
  metadata?: {
    temperature?: number;
    max_tokens?: number;
    model?: string;
  };
}

export const AI_PROMPT_PURPOSES: {
  value: AiPromptPurpose;
  label: string;
  description: string;
}[] = [
  {
    value: "system",
    label: "System Prompt",
    description:
      "Main system prompt that defines the AI assistant's identity and behavior.",
  },
  {
    value: "summarization",
    label: "Summarization",
    description:
      "Prompt used to summarize older messages in a chat session to compress context.",
  },
  {
    value: "profile_extraction",
    label: "Profile Extraction",
    description:
      "Lightweight prompt for extracting user profile signals from chat conversations.",
  },
];
